export default __webpack_public_path__ + "static/media/george.c8b3d126.jpg";